import React from 'react';
import { Navigate, Outlet, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { LOGIN_SWITCH_ACCOUNT_QUERY, ROUTES } from '@/routes/paths';

/**
 * Guest-only routes (login, forgot password).
 * When ?switch=1 (from account email), do not redirect — LoginPage will clear the old session.
 */
export function GuestRoute() {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const switchAccount = searchParams.get(LOGIN_SWITCH_ACCOUNT_QUERY) === '1';

  if (user && !switchAccount) {
    if (user.mustChangePassword) {
      return <Navigate to={ROUTES.changePassword} replace />;
    }
    return <Navigate to={ROUTES.dashboard(user.role)} replace />;
  }

  return <Outlet />;
}
